module.exports = __webpack_public_path__ + "img/undraw_winners_ao2o.d277eaf8.svg";